import {
  AttributeOptions,
  IngressRequestForm,
  MultiSelectOption,
} from '@dispatch/shared/types';
import { Section, SelectField, TextField } from '@dispatch/web/ui';
import { Close } from '@mui/icons-material';
import { Divider, Grid, IconButton } from '@mui/material';
import { useMemo } from 'react';
import {
  Control,
  FieldValues,
  UseFieldArrayRemove,
  UseFormGetValues,
} from 'react-hook-form';

export type IngressClaimAttributesFormProps = {
  control: Control<FieldValues>;
  claimAttributeIndex: number;
  claimAttributeRemove: UseFieldArrayRemove;
  field: Record<'id', string>;
  getValues: UseFormGetValues<IngressRequestForm>;
  companyAttributes: AttributeOptions[];
  isReview?: boolean;
};

export function IngressClaimAttributesForm({
  control,
  claimAttributeIndex,
  claimAttributeRemove,
  field,
  getValues,
  companyAttributes,
  isReview,
}: IngressClaimAttributesFormProps) {
  const { companyAttribute, isMultiSelect, options } = useMemo(() => {
    const companyAttribute = companyAttributes.find(
      (attribute) =>
        getValues(
          `claimAttributes.${claimAttributeIndex}.attributeDefinitionIntegrationGUID`
        ) === attribute.value
    );

    const isMultiSelect = companyAttribute?.valueType?.includes('multi-select');

    const options =
      companyAttribute?.attributeDefinitionValues.map((value) => {
        return {
          title: value.title,
          value: value.value,
        };
      }) || [];

    return {
      companyAttribute,
      isMultiSelect,
      options,
    };
  }, [claimAttributeIndex, companyAttributes, getValues]);

  const deleteAttribute = (index: number) => {
    claimAttributeRemove(index);
  };

  const renderClaimAttributes = () => {
    return (
      <>
        <div
          style={{
            padding: '24px',
          }}
        >
          <Grid container rowSpacing={4} key={field.id}>
            <Grid item xs={6}>
              <TextField
                id={`claimAttributes.${claimAttributeIndex}.displayName`}
                name={`claimAttributes.${claimAttributeIndex}.displayName`}
                label="Attribute"
                type="text"
                control={control}
                inputProps={{
                  readOnly: true,
                  endAdornment: (
                    <IconButton
                      onClick={() => deleteAttribute(claimAttributeIndex)}
                    >
                      <Close />
                    </IconButton>
                  ),
                }}
                disabled={isReview}
              />
            </Grid>
            <Grid item xs={10}>
              <SelectField
                multiple={isMultiSelect}
                id={`claimAttributes.${claimAttributeIndex}.selectedAttributeValuesVarchars`}
                name={`claimAttributes.${claimAttributeIndex}.selectedAttributeValuesVarchars`}
                label={companyAttribute?.title}
                control={control}
                options={options as MultiSelectOption[]}
                isOptionEqualToValue={(
                  option: MultiSelectOption,
                  selectValue: any
                ) => {
                  return (
                    option.value === selectValue?.value ||
                    option.value === selectValue
                  );
                }}
                disabled={isReview}
              />
            </Grid>
          </Grid>
        </div>
        <Divider />
      </>
    );
  };

  return <Section>{renderClaimAttributes()}</Section>;
}
